// project hash key
// e921d896b24ee51ad95dc303a034758da1187532b0a44189bd99aa333255781b

import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory, useParams, Link } from 'react-router-dom';
import { ON_SALE, USE_POINT_CHILD_LEVEL, USE_POINT_PARENT_LEVEL } from '../../../constants';
import TButton from '../../common/button';
import JSCookie from 'js-cookie';
import FloatPanel from './FloatPanel';

import { dotted } from '../../../../assets/imgs';

const renderBorderDot = () => {
  return (
    <div
      className="border-dots border-dots-detail"
      style={{
        backgroundImage: `url(${dotted})`,
        backgroundSize: '65%',
        backgroundRepeatY: 'no-repeat',
        height: '5px',
      }}
    ></div>
  );
};

export default function OverViews(props) {
  const { data } = props;
  const lotteryEvent = data?.lottery_event;
  const refundRate = lotteryEvent?.refund_point_rate;
  const hasCancelFlag = lotteryEvent?.has_cancel_flag;
  const hasUsePointFlag = lotteryEvent?.has_use_point_flag;
  const usePointFlag = lotteryEvent?.use_point_flag;

  const canUsePointFlag =
    usePointFlag === USE_POINT_PARENT_LEVEL.canUsePoint &&
    hasUsePointFlag === USE_POINT_CHILD_LEVEL.canUsePoint;

  const priceIncludeTax = Math.floor(
    lotteryEvent?.price + (lotteryEvent?.price * lotteryEvent?.tax_rate) / 100,
  ).toLocaleString('ja-JP');

  const saleStatus = lotteryEvent?.sale_status;
  const { id } = useParams();

  const { t } = useTranslation();

  const history = useHistory();

  const handleClick = () => {
    history.push(`/purchase/${id}`);
  };

  const token = JSCookie.get('token');

  const pathLotteryTrial = '/trial';
  const pathSite = history.location.pathname;
  return (
    <>
      <div
        className="border-dots"
        style={{
          backgroundImage: `url(${dotted})`,
          backgroundSize: '1200px',
          backgroundRepeatY: 'no-repeat',
          height: '10px',
        }}
      ></div>
      <div className="overview-lottery-detail">
        <div className="text-center">
          <h1 className="title-overview AOTFShinMaruGoPro">{lotteryEvent.name}</h1>
          <div className="title-description my-color-black-400">
            <p>{lotteryEvent.description}</p>
          </div>
        </div>
        <FloatPanel data={data} />
        <div className="my-overview-content-pc">
          <table className="table table-borderless table-overviews my-color-black-400">
            <tbody>
              {pathLotteryTrial !== pathSite && (
                <>
                  <tr className="overview-info">
                    <td colSpan={2} style={{ padding: '0px' }}>
                      {renderBorderDot()}
                    </td>
                  </tr>
                  <tr className="overview-info">
                    <td scope="col">
                      <span className="my-tag my-bg-dark-red">{t('lotteryEventStartDate')}</span>
                    </td>
                    <td className="d-flex flex-column">
                      <span scope="col" className="no-padding" style={{ display: 'block' }}>
                        {lotteryEvent?.start_date_format?.replace('から', '~')}{' '}
                        {lotteryEvent?.end_date_format}
                      </span>
                    </td>
                  </tr>
                </>
              )}
              <tr className="overview-info">
                <td colSpan={2} style={{ padding: '0px' }}>
                  {renderBorderDot()}
                </td>
              </tr>
              <tr className="overview-info">
                <td scope="col">
                  <span className="my-tag my-bg-dark-red">{t('lotteryEventPrice')}</span>
                </td>
                <td scope="col">
                  {t('priceLottery').replace(
                    'param',
                    pathLotteryTrial === pathSite
                      ? 0
                      : Math.floor(
                          lotteryEvent?.price +
                            (lotteryEvent?.price * lotteryEvent?.tax_rate) / 100,
                        ).toLocaleString('ja-JP'),
                  )}
                </td>
              </tr>
              <tr className="overview-info">
                <td colSpan={2} style={{ padding: '0px' }}>
                  {renderBorderDot()}
                </td>
              </tr>
              <tr className="overview-info">
                <td scope="col">
                  <span className="my-tag my-bg-dark-red">{t('lotteryEventTransportFee')}</span>
                </td>
                <td scope="col">
                  {pathLotteryTrial === pathSite ? 'なし' : lotteryEvent.shipping_fee}
                </td>
              </tr>
              <tr className="overview-info">
                <td colSpan={2} style={{ padding: '0px' }}>
                  {renderBorderDot()}
                </td>
              </tr>

              <tr className="overview-info">
                <td scope="col">
                  <span className="my-tag my-bg-dark-red">{t('lotteryEventRefundRate')}</span>
                </td>
                <td scope="col">
                  {!hasCancelFlag ? (
                    <span>このくじは破棄対象外です　</span>
                  ) : (
                    <span>
                      1枚破棄につき、販売価格({priceIncludeTax}円(税込))の{refundRate}
                      %をポイント還元　
                    </span>
                  )}
                  <Link to="/frequently-question#Q5">詳しくはこちら</Link>
                </td>
              </tr>
              <tr className="overview-info">
                <td colSpan={2} style={{ padding: '0px' }}>
                  {renderBorderDot()}
                </td>
              </tr>

              <tr className="overview-info">
                <td scope="col">
                  <span className="my-tag my-bg-dark-red">{t('lotteryEventCanUsePoint')}</span>
                </td>
                <td scope="col">
                  {canUsePointFlag ? 'ポイント利用可能　' : 'ポイント利用不可　'}
                  <Link to="/frequently-question#Q6">詳しくはこちら</Link>
                </td>
              </tr>
              <tr className="overview-info">
                <td colSpan={2} style={{ padding: '0px' }}>
                  {renderBorderDot()}
                </td>
              </tr>
              <tr className="overview-info">
                <td scope="col">
                  <span className="my-tag my-bg-dark-red">{t('lotteryEventEstimateDelivery')}</span>
                </td>
                <td scope="col">
                  {pathLotteryTrial === pathSite
                    ? 'お届けはありません。'
                    : lotteryEvent.estimated_delivery_date}
                </td>
              </tr>

              <tr className="overview-info">
                <td colSpan={2} style={{ padding: '0px' }}>
                  {renderBorderDot()}
                </td>
              </tr>
              <tr className="overview-info">
                <td scope="col">
                  <span className="my-tag my-bg-black-200">{t('lotteryEventTermsToPay')}</span>
                </td>
                <td scope="col" className="my-terms-to-pay NotoSansJP400">
                  {pathLotteryTrial === pathSite
                    ? t('termsToPayAttentionTrial')
                    : t('termsToPayAttention')}
                </td>
              </tr>

              <tr className="overview-info">
                <td colSpan={2} style={{ padding: '0px' }}>
                  {renderBorderDot()}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        {lotteryEvent?.banner_image?.image_url && (
          <div className="banner-overview">
            <img src={lotteryEvent?.banner_image?.image_url} alt="banner" />
          </div>
        )}
        {pathSite === pathLotteryTrial && (
          <div className="text-center my-btn-progress-purchase">
            <TButton
              title={t('buttonProgressToPurchase')}
              onClick={() => history.push('/purchase/trial')}
              className={'tertiary'}
            />
          </div>
        )}
        {token && pathSite !== pathLotteryTrial && (
          <div className="text-center my-btn-progress-purchase">
            <TButton
              title={
                saleStatus === ON_SALE
                  ? t('buttonProgressToPurchase')
                  : saleStatus === 0
                  ? t('textPrepare')
                  : t('textOffSale')
              }
              onClick={handleClick}
              className={saleStatus === ON_SALE ? 'tertiary' : 'btn-disable-purchase'}
              disabled={saleStatus !== ON_SALE}
              isIcon={saleStatus === ON_SALE}
            />
          </div>
        )}
        {!token && pathSite !== pathLotteryTrial && (
          <div className="d-flex justify-content-center mb-5 button-wrapper block-authentication">
            <TButton
              className="secondary me-3"
              title="新規会員登録"
              onClick={() => history.push('/register')}
            />
            <TButton
              className="primary"
              title="ログイン"
              onClick={() => history.push(`/login?callbackUrl=%2Flottery%2F${id}`)}
            />
          </div>
        )}
      </div>
    </>
  );
}
